<template>
  <section class="page-container">
    <div class="admin-main">
      <el-container>
        <el-aside>
          <el-tree
            :data="treeData"
            :props="treeProps"
            node-key="id"
            default-expand-all
            highlight-current
            :expand-on-click-node="false"
            :current-node-key="0"
            @node-click="treeNodeClick"
          >
          </el-tree>
        </el-aside>
        <el-main style="padding: 0; margin-left: 10px">
          <div class="admin-toolbar">
            <el-button type="primary" size="small" @click="showCreateDialog"
              >{{
                filters.parentId > 0 && filters.parentName
                  ? `在【${filters.parentName}】下创建子条目`
                  : "创建顶级条目"
              }}
            </el-button>
            <el-button type="success" size="small" @click="refresh">刷新</el-button>
          </div>
          <el-table :data="results" border style="width: 100%">
            <el-table-column prop="id" label="编号" width="180" />
            <el-table-column prop="title" label="标题" width="180" />
            <el-table-column prop="content" label="内容" />
            <el-table-column prop="imageList" label="图片">
              <template slot-scope="scope">
                <div v-if="scope.row.imageList && scope.row.imageList.length">
                  <el-image
                    v-for="(image, index) in scope.row.imageList"
                    :key="index"
                    :src="image.preview"
                    :preview-src-list="imageSrcList(scope.row.imageList)"
                    fit="cover"
                    lazy
                    style="width: 100px; height: 100px; margin-right: 10px"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <!--
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                {{ scope.row.status === 0 ? '正常' : '删除' }}
              </template>
            </el-table-column>
            -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="small" @click="showUpdateDialog(scope.row.id)">编辑 </el-button>
                <el-button size="small" type="danger" @click="deleteQA(scope.row.id)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <my-pagination
            :page="page"
            @current-change="handlePageChange"
            @size-change="handleLimitChange"
          />
        </el-main>
      </el-container>
    </div>

    <el-dialog title="创建" width="80%" :visible.sync="dialogCreateVisible">
      <el-form :model="createForm" label-position="right" label-width="80px">
        <el-form-item label="标题：">
          <el-input v-model="createForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input v-model="createForm.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容：">
          <el-input
            v-model="createForm.content"
            type="textarea"
            rows="10"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片：">
          <admin-batch-image-upload v-model="createForm.imageList" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCreateDialog">取 消</el-button>
        <el-button type="primary" @click="submitCreate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="dialogUpdateVisible">
      <el-form :model="updateForm" label-position="right" label-width="80px">
        <el-form-item label="标题：">
          <el-input v-model="updateForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input v-model="updateForm.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容：">
          <el-input
            v-model="updateForm.content"
            type="textarea"
            rows="6"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="updateForm.status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="删除" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片：">
          <admin-batch-image-upload v-model="updateForm.imageList" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" @click="submitUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      treeProps: {
        label: "title",
        children: "childNodes",
      },
      dialogCreateVisible: false,
      createForm: {
        title: "",
        content: "",
        imageList: "",
        parentId: 0,
        sort: "",
      },
      dialogUpdateVisible: false,
      updateForm: {
        id: 0,
        title: "",
        content: "",
        imageList: "",
        parentId: 0,
        sort: "",
        status: 0,
      },

      filters: {
        parentId: 0,
        parentName: "",
      },
      results: [],
      page: {},

      treeData: [],
    };
  },
  watch: {
    createForm(value) {
      console.log(value);
    },
  },
  mounted() {
    this.loadCategoriesTree();
    this.list();
  },
  methods: {
    async list() {
      const params = Object.assign(this.filters, {
        page: this.page.page || 1,
        limit: this.page.limit || 30,
      });
      const data = await this.axios.form("base:/api/admin/qa/list", params);
      this.results = data.results;
      this.page = data.page;
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    showCreateDialog() {
      this.resetCreateForm();
      this.createForm.parentId = this.filters.parentId;
      this.dialogCreateVisible = true;
    },
    closeCreateDialog() {
      this.dialogCreateVisible = false;
    },
    async submitCreate() {
      try {
        await this.axios.form("base:/api/admin/qa/create", this.createForm);
        await this.list();
        await this.loadCategoriesTree();
        this.resetCreateForm();
        this.dialogCreateVisible = false;
      } catch (e) {
        this.$message.error(e.message || "提交失败");
      }
    },
    resetCreateForm() {
      this.createForm.title = "";
      this.createForm.content = "";
      this.createForm.imageList = "";
      this.createForm.parentId = 0;
      this.createForm.sort = "";
    },
    async showUpdateDialog(id) {
      try {
        const qa = await this.axios.get("base:/api/admin/qa/" + id);
        this.updateForm.id = qa.id;
        this.updateForm.title = qa.title;
        this.updateForm.content = qa.content;
        if (qa.imageList) {
          this.updateForm.imageList = qa.imageList;
        }
        this.updateForm.parentId = qa.parentId;
        this.updateForm.sort = qa.sort;
        this.updateForm.status = qa.status;
        this.dialogUpdateVisible = true;
      } catch (e) {
        this.$message.error(e.message || "获取数据失败");
      }
    },
    async deleteQA(id) {
      try {
        await this.axios.get("base:/api/admin/qa/delete?id=" + id);
        await this.refresh();
        this.$message.error("删除成功");
      } catch (e) {
        this.$message.error(e.message || "获取数据失败");
      }
    },
    closeUpdateDialog() {
      this.dialogUpdateVisible = false;
    },
    async submitUpdate() {
      try {
        await this.axios.form("base:/api/admin/qa/update", this.updateForm);
        await this.list();
        await this.loadCategoriesTree();
        this.closeUpdateDialog();
      } catch (e) {
        this.$message.error(e.message || "修改失败");
      }
    },
    async loadCategoriesTree() {
      try {
        this.treeData = [await this.axios.get("base:/api/admin/qa/tree")];
        // const nodes = await this.axios.get('/api/admin/qa/tree')
        // this.treeData = [
        //   {
        //     id: 0,
        //     title: '知识库',
        //     childNodes: nodes,
        //   },
        // ]
      } catch (e) {
        this.$message.error(e.message || "数据加载时报");
      }
    },
    async treeNodeClick(data) {
      this.filters.parentId = data.id;
      this.filters.parentName = data.title;
      await this.list();
    },
    async refresh() {
      await this.loadCategoriesTree();
      await this.list();
    },
    imageSrcList(imageList) {
      if (!imageList || !imageList.length) {
        return [];
      }
      const ret = [];
      for (let i = 0; i < imageList.length; i++) {
        ret.push(imageList[i].preview);
      }
      return ret;
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-main {
  padding: 20px;

  .admin-toolbar {
    margin-bottom: 10px;
  }
}
</style>
